import { render, staticRenderFns } from "./LinkDigiventures.vue?vue&type=template&id=a4b3b13e"
import script from "./LinkDigiventures.vue?vue&type=script&lang=js"
export * from "./LinkDigiventures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports